import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { SITE, NAV_ITEMS, WHATSAPP } from "../lib/siteConfig";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,backdrop-filter,border] duration-500 ${scrolled ? "backdrop-blur-xl bg-[#FDFBF7]/90 border-b border-[rgba(34,34,34,0.08)]" : "bg-black/10 backdrop-blur-[2px] border-b border-white/10"}`}
      data-testid="site-header"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 flex items-center justify-between py-4">
        <a href="#top" className="flex items-center gap-3 group max-w-[390px]" data-testid="logo-link">
          <img src={SITE.brand.logoSrc} alt={SITE.brand.logoAlt} className="h-12 sm:h-14 w-auto max-w-[150px] object-contain object-left" />
          <div className={`hidden sm:flex flex-col leading-tight ${scrolled ? "text-[#222]" : "text-white"}`}>
            <span className="font-display text-[1.05rem] tracking-tight">{SITE.brand.shortName}</span>
            <span className="text-[0.55rem] uppercase tracking-[0.18em] font-semibold opacity-85">{SITE.brand.fullName}</span>
          </div>
        </a>
        <nav className="hidden lg:flex items-center gap-10" data-testid="main-nav">
          {NAV_ITEMS.map((item) => <a key={item.label} href={item.href} className={`nav-link link-under ${scrolled ? "" : "!text-white"}`} data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>{item.label}</a>)}
        </nav>
        <div className="hidden lg:flex items-center gap-4">
          <a href={WHATSAPP} target="_blank" rel="noreferrer" className="btn-emerald" data-testid="header-book-driver-btn">Book Now <ArrowUpRight size={16} strokeWidth={1.6} /></a>
        </div>
        <button onClick={() => setOpen((s) => !s)} className="lg:hidden w-11 h-11 rounded-full border border-white/50 text-white flex items-center justify-center" data-testid="mobile-menu-toggle" aria-label="Toggle menu">{open ? <X size={18} /> : <Menu size={18} />}</button>
      </div>
      <AnimatePresence>
        {open && <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }} className="lg:hidden overflow-hidden bg-[#FDFBF7] border-t border-[rgba(34,34,34,0.08)]" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_ITEMS.map((n) => <a key={n.label} href={n.href} onClick={() => setOpen(false)} className="text-xl font-display tracking-tight" data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}>{n.label}</a>)}
            <a href={WHATSAPP} target="_blank" rel="noreferrer" className="btn-emerald mt-2 justify-center">Book Now <ArrowUpRight size={16} strokeWidth={1.6} /></a>
          </div>
        </motion.div>}
      </AnimatePresence>
    </motion.header>
  );
}
